import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function ReportForm({ onSuccess }) {
  const [postType, setPostType] = useState('idea');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const savedEmail = localStorage.getItem('memogram_email');
    const savedName = localStorage.getItem('memogram_name');
    if (savedEmail) setEmail(savedEmail);
    if (savedName) setName(savedName);
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!email) {
      newErrors.email = 'メールアドレスを入力してください';
    } else if (!email.includes('@')) {
      newErrors.email = '有効なメールアドレスを入力してください';
    }
    
    if (!name.trim()) {
      newErrors.name = 'お名前を入力してください';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);
    setErrors({});

    localStorage.setItem('memogram_email', email);
    localStorage.setItem('memogram_name', name);

    const hour = new Date().getHours();
    const session = (hour >= 6 && hour < 18) ? 'day' : 'night';
    const action_type = postType === 'idea' ? 'memogram_idea_self_report' : 'memogram_growth_self_report';
    const memogram_type = postType === 'idea' ? 'memogram_idea' : 'memogram_growth';

    const payload = {
      email,
      name,
      action_type,
      points: 10,
      session,
      detail: {
        type: "self_report",
        source: "greta",
        memogram_type,
        reported_at: new Date().toISOString()
      }
    };

    try {
      const response = await fetch('https://whpqheywobndaeaikchh.supabase.co/rest/v1/remo_activity_log', {
        method: 'POST',
        headers: {
          'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndocHFoZXl3b2JuZGFlYWlrY2hoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3NzU4NTksImV4cCI6MjA4NTM1MTg1OX0.t-ZVO9ulPD-rvta7P7Ii2W09BsctJHR_YqmAY03nSsw',
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndocHFoZXl3b2JuZGFlYWlrY2hoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3NzU4NTksImV4cCI6MjA4NTM1MTg1OX0.t-ZVO9ulPD-rvta7P7Ii2W09BsctJHR_YqmAY03nSsw',
          'Content-Type': 'application/json',
          'Prefer': 'return=minimal'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('API Request Failed');
      onSuccess();
    } catch (error) {
      setErrors({ submit: '送信に失敗しました。時間をおいて再度お試しください。' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Type Selection */}
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => setPostType('idea')}
          className={`flex-1 py-3 px-2 rounded-xl text-sm font-medium transition-colors duration-200 flex items-center justify-center gap-1.5 ${
            postType === 'idea' 
              ? 'bg-brand-main text-white shadow-lg shadow-brand-main/20' 
              : 'bg-brand-bg text-gray-400 hover:bg-[#1f1f33]'
          }`}
        >
          <span className="text-lg">💡</span>
          <span>アイデア・実践の記録</span>
        </button>
        <button
          type="button"
          onClick={() => setPostType('growth')}
          className={`flex-1 py-3 px-2 rounded-xl text-sm font-medium transition-colors duration-200 flex items-center justify-center gap-1.5 ${
            postType === 'growth' 
              ? 'bg-brand-main text-white shadow-lg shadow-brand-main/20' 
              : 'bg-brand-bg text-gray-400 hover:bg-[#1f1f33]'
          }`}
        >
          <span className="text-lg">📈</span>
          <span>日々の成長報告</span>
        </button>
      </div>

      {/* Inputs */}
      <div className="space-y-4">
        <div>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="メールアドレス（必須）"
            disabled={isLoading}
            className={`w-full bg-brand-bg border ${
              errors.email ? 'border-red-500' : 'border-[#3A3A52]'
            } rounded-xl px-4 py-3.5 text-white placeholder-gray-500 focus:outline-none focus:border-brand-main transition-colors`}
          />
          {errors.email && <p className="text-red-400 text-xs mt-1.5 ml-1">{errors.email}</p>}
        </div>

        <div>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="お名前・ニックネーム（必須）"
            disabled={isLoading}
            className={`w-full bg-brand-bg border ${
              errors.name ? 'border-red-500' : 'border-[#3A3A52]'
            } rounded-xl px-4 py-3.5 text-white placeholder-gray-500 focus:outline-none focus:border-brand-main transition-colors`}
          />
          {errors.name && <p className="text-red-400 text-xs mt-1.5 ml-1">{errors.name}</p>}
        </div>
      </div>

      {errors.submit && (
        <div className="p-3 bg-red-500/10 border border-red-500/50 rounded-lg text-red-400 text-sm text-center">
          {errors.submit}
        </div>
      )}

      {/* Submit Button - Updated to brand-main (Green) */}
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        type="submit"
        disabled={isLoading}
        className="w-full bg-brand-main text-white font-bold py-4 px-4 rounded-xl shadow-lg shadow-brand-main/20 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed transition-all"
      >
        {isLoading ? (
          <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
        ) : (
          <>
            <span className="text-xl">📮</span>
            <span>投稿しました！ <span className="text-brand-accent ml-1">+10pt</span></span>
          </>
        )}
      </motion.button>
    </form>
  );
}